import { render, staticRenderFns } from "./YoutubeLicensing.vue?vue&type=template&id=316c743d"
import script from "./YoutubeLicensing.vue?vue&type=script&lang=js"
export * from "./YoutubeLicensing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports